import { Media, Setting } from '@/payload-types';
import { MediaComponent } from '@/components/Media';

export default function ProductKeyFeatures(props: Setting['product']) {
  const { features } = props || {};
  return (
    <ul className='grid grid-cols-2 lg:grid-cols-3 my-6 gap-x-2 gap-y-4'>
      {features?.map((feature, index) => (
        <li key={`${feature.id}-${index}`} className='flex gap-2'>
          <MediaComponent
            resource={{ ...(feature.logo as Media), width: 24, height: 24 }}
            imgClassName='w-6 h-6 object-contain'
            placeholder="empty"
          />
          <span className='flex-1'>{feature.name}</span>
        </li>
      ))}
    </ul>
  );
}
